import LanguageContent, {
  LegislationContent,
  SidebarContent,
} from "@/models/i18n/LanguageContent";
import LaraIcon from "@/assets/lara/lara-icon.svg";

import LodaDarkGreenIcon from "@/assets/loda/loda-dark-green-icon.svg";
import LodaLightGreenIcon from "@/assets/loda/loda-light-green-icon.svg";

import LodaDarkGreenLogo from "@/assets/loda/loda-dark-green-logo.svg";
import LodaLightGreenLogo from "@/assets/loda/loda-light-green-logo.svg";

const LODA_DEFAULT_SIDEBAR_CONTENT_DA: SidebarContent = {
  open: {
    logo: {
      dark: LodaDarkGreenLogo,
      light: LodaLightGreenLogo,
    },
  },
  collapsed: {
    logo: {
      dark: LodaDarkGreenIcon,
      light: LodaLightGreenIcon,
    },
  },
};

const DEFAULT_LEGISLATION_CONTENT_DA: LegislationContent = {
  listView: {
    heading: "Kilder",
  },
};

const LARA_DEFAULT_CHAT_CONTENT_DA = {
  disclaimer:
    "Lara kan tage fejl. Kontroller vigtige oplysninger med den officielle kilde.",
  inputPlaceholder: "Spørg Lara...",
  icon: LaraIcon,
  emptyState: {
    greeting: {
      headline: "Lad os gøre din juridiske research lettere.",
      subtitle: "Din AI-assistent til kilder, workspaces og klausultjek.",
    },
    cards: {
      legalSources: {
        title: "Kilder",
        description:
          "Tilføj Retsinformationen, Domsdatabasen, Arvid eller andre kilder for dokumenterede svar.",
      },
      ownSources: {
        title: "Egne kilder",
        description:
          "Arbejd i dine sager. Tilføj workspace, mapper eller enkelte filer.",
      },
      prompts: {
        title: "Prompt-bibliotek",
        description:
          "Start med skabeloner: klausultjek, find praksis, sammenlign versioner.",
      },
    },
  },
  context: {
    noContextSelected: "Ingen kilder valgt",
    noContextWarning:
      "Ingen kilder valgt. Lara har kun adgang til information, du giver den, som kan resultere i ukorrekte svar.",
    addSource: "Tilføj kilde",
    addWorkspace: "Tilføj workspace",
    cannotAddSourceMessage:
      "Du kan ikke tilføje kilder når du har valgt egne kilder. Fjern egne kilder først for at tilføje kilder.",
    cannotAddWorkspaceMessage:
      "Du kan ikke tilføje egne kilder når du har valgt kilder. Fjern kilder først for at tilføje egne kilder.",
    conversationStartsAutomatically:
      "Når du har valgt kilder, starter samtalen automatisk",
    selectWorkspaceTitle: "Vælg workspace mapper & filer",
    alreadyHasSourcesMessage:
      "Du har allerede valgt kilder. For at tilføje egne kilder, skal du først fjerne kilder.",
    noWorkspaceFilesFound: "Ingen workspace mapper eller filer fundet",
    confirm: "Start samtale",
    filterCount: "{{count}} filtre",
    dontShowAgain: "Vis ikke denne dialog igen",
    continueAnyway: "Fortsæt uden kilder",
    currentDataOnly:
      "Svar baseres kun på gældende data. Historiske data er udelukket.",
  },
  sourceSelection: {
    title: "Vælg kilder",
    availableSources: "Tilgængelige kilder",
    configureFiltersFor: "Konfigurer filtre for:",
    selectSourceToConfigure:
      "Vælg en kilde til venstre for at konfigurere filtre",
    cancel: "Annuller",
    addSource: "Tilføj kilde",
    sourceSelected: "1 kilde valgt",
    cannotAddSourceWarning:
      "Du har allerede valgt egne kilder. For at tilføje kilder skal du først fjerne egne kilder.",
    cannotAddSourceTooltip:
      "Du kan ikke tilføje kilder når du har valgt egne kilder. Fjern egne kilder først.",
    selectSourcePrompt: "Vælg venligst en kilde.",
  },
};

const LODA_DEFAULT_CHAT_CONTENT_DA = {
  disclaimer:
    "Loda kan tage fejl. Kontroller vigtige oplysninger med den officielle kilde.",
  inputPlaceholder: "Spørg Loda...",
  icon: LodaDarkGreenIcon,
  emptyState: {
    greeting: {
      headline: "Lad os gøre din juridiske research lettere.",
      subtitle: "Din AI-assistent til kilder, workspaces og klausultjek.",
    },
    cards: {
      legalSources: {
        title: "Kilder",
        description:
          "Tilføj Retsinformationen, Domsdatabasen, Arvid eller andre kilder for dokumenterede svar.",
      },
      ownSources: {
        title: "Egne kilder",
        description:
          "Arbejd i dine sager. Tilføj workspace, mapper eller enkelte filer.",
      },
      prompts: {
        title: "Prompt-bibliotek",
        description:
          "Start med skabeloner: klausultjek, find praksis, sammenlign versioner.",
      },
    },
  },
  context: {
    noContextSelected: "Ingen kilder valgt",
    noContextWarning:
      "Ingen kilder valgt. Loda har kun adgang til information, du giver den, som kan resultere i ukorrekte svar.",
    addSource: "Tilføj kilde",
    addWorkspace: "Tilføj workspace",
    cannotAddSourceMessage:
      "Du kan ikke tilføje kilder når du har valgt egne kilder. Fjern egne kilder først for at tilføje kilder.",
    cannotAddWorkspaceMessage:
      "Du kan ikke tilføje egne kilder når du har valgt kilder. Fjern kilder først for at tilføje egne kilder.",
    selectWorkspaceTitle: "Vælg workspace mapper & filer",
    alreadyHasSourcesMessage:
      "Du har allerede valgt kilder. For at tilføje egne kilder, skal du først fjerne kilder.",
    noWorkspaceFilesFound: "Ingen workspace mapper eller filer fundet",
    confirm: "Start samtale",
    filterCount: "{{count}} filtre",
    dontShowAgain: "Vis ikke denne dialog igen",
    conversationStartsAutomatically:
      "Når du har valgt kilder, starter samtalen automatisk",
    continueAnyway: "Fortsæt uden kilder",
    currentDataOnly:
      "Svar baseres kun på gældende data. Historiske data er udelukket.",
  },
  sourceSelection: {
    title: "Vælg kilder",
    availableSources: "Tilgængelige kilder",
    configureFiltersFor: "Konfigurer filtre for:",
    selectSourceToConfigure:
      "Vælg en kilde til venstre for at konfigurere filtre",
    cancel: "Annuller",
    addSource: "Tilføj kilde",
    sourceSelected: "1 kilde valgt",
    cannotAddSourceWarning:
      "Du har allerede valgt egne kilder. For at tilføje kilder, skal du først fjerne egne kilder.",
    cannotAddSourceTooltip:
      "Du kan ikke tilføje kilder, når du har valgt egne kilder. Fjern egne kilder først.",
    selectSourcePrompt: "Vælg venligst en kilde.",
  },
};

const LARA_DEFAULT_AUTH_CONTENT_DA = {
  logo: LaraIcon,
  text: "Log ind for at fortsætte",
  button: {
    signIn: "Log ind",
    signOut: "Log ud",
  },
  theme: {
    toLight: "Skift til lys tilstand",
    toDark: "Skift til mørk tilstand",
  },
};

const LODA_DEFAULT_AUTH_CONTENT_DA = {
  logo: LodaDarkGreenLogo,
  text: "Log ind for at fortsætte",
  button: {
    signIn: "Log ind",
    signOut: "Log ud",
  },
  theme: {
    toLight: "Skift til lys tilstand",
    toDark: "Skift til mørk tilstand",
  },
};

export const LARA_DEFAULT_CONTENT_DA: LanguageContent = {
  // sidebar: intentionally omitted - uses fallback in AppSidebarHeader
  legislation: DEFAULT_LEGISLATION_CONTENT_DA,
  chat: LARA_DEFAULT_CHAT_CONTENT_DA,
  auth: LARA_DEFAULT_AUTH_CONTENT_DA,
};

export const LODA_DEFAULT_CONTENT_DA: LanguageContent = {
  sidebar: LODA_DEFAULT_SIDEBAR_CONTENT_DA,
  legislation: DEFAULT_LEGISLATION_CONTENT_DA,
  chat: LODA_DEFAULT_CHAT_CONTENT_DA,
  auth: LODA_DEFAULT_AUTH_CONTENT_DA,
};
